<h2 class="text-center mb-4">Forgot your password?</h2>
<form #forgotpasswordForm="ngForm" name="forgotpasswordForm" class="m-0" (ngSubmit)="OnSubmit(Email.value)" autocomplete="off">
  <div class="fieldset">
    <label for="Email" class="legend">Email</label>
    <input type="email" name="Email" id="Email" class="text-field" [disabled]="this.resetService.isLoading" ngModel #Email required>
  </div>
  <button *ngIf="!this.resetService.isLoading; else isLoading" type="submit" class="btn" [disabled]="this.forgotpasswordForm.invalid">Send reset link to my email</button>
  <ng-template #isLoading>
    <button class="btn btn--loading" type="button">Sending email...</button>
  </ng-template>
</form>
